/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Attestation } from './Attestation';
import {
    AttestationFromJSON,
    AttestationFromJSONTyped,
    AttestationToJSON,
} from './Attestation';

/**
 * 
 * @export
 * @interface AttestationReponse
 */
export interface AttestationReponse {
    /**
     * 
     * @type {Attestation}
     * @memberof AttestationReponse
     */
    data?: Attestation;
}

/**
 * Check if a given object implements the AttestationReponse interface.
 */
export function instanceOfAttestationReponse(value: object): value is AttestationReponse {
    let isInstance = true;

    return isInstance;
}

export function AttestationReponseFromJSON(json: any): AttestationReponse {
    return AttestationReponseFromJSONTyped(json, false);
}

export function AttestationReponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttestationReponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : AttestationFromJSON(json['data']),
    };
}

export function AttestationReponseToJSON(value?: AttestationReponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': AttestationToJSON(value.data),
    };
}

